export enum PlanAdminFilterKey {
  IsActive = 'isActive',
  BillingCycle = 'billingCycle',
}

export const PLAN_ADMIN_FILTER_KEYS = [PlanAdminFilterKey.IsActive, PlanAdminFilterKey.BillingCycle];
